/**
 * Decodes a base64 encoded string into an object.
 * @function decodeFromBase64
 * @param {string} encodedMessage - The base64 encoded string.
 * @returns {Record<string, unknown>} The decoded object.
 */
export const decodeFromBase64 = (
  encodedMessage: string,
): Record<string, unknown> => {
  // Decode the base64 string to a JSON string
  const jsonString = atob(encodedMessage);
  // Parse the JSON string back to an object
  const decodedObject = JSON.parse(jsonString);
  return decodedObject;
};
